import {
  EUpsertSegmnetsResultStatus,
  UpsertSegmnetEntry,
  UpsertSegmnetsResultEntry,
} from "../../domain/media";

export class ImportSegmentsViewModel {
  public resultTable: UpsertSegmnetsResultEntry[] = [];
  public selectedFile: File;
  public showPreloader = false;
  private _fileElement: HTMLInputElement;

  constructor(private _api: IImportSegmentsViewModelApiProxy) {}

  onFileChanges(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    const fileList: FileList | null = element.files;
    if (fileList && fileList.length > 0) {
      this.selectedFile = fileList[0];
      this._fileElement = element;
    }

    this._api.updateUI();
  }

  formatStatus(status: EUpsertSegmnetsResultStatus): string {
    return EUpsertSegmnetsResultStatus[status];
  }

  async onUploadClickEventHandler() {
    this.showPreloader = true;
    this.resultTable = [];
    this._api.updateUI();

    if (this.selectedFile) {
      try {
        const parsedCsvData = await this._api.fileToRowObjectsArray(
          this.selectedFile,
        );
        const convertedData = this.convertToUploadCsvFormat(parsedCsvData);
        if (convertedData) {
          console.log(
            "import-segments-vm->onUploadClickEventHandler->convertedData",
            convertedData,
          );
          this.resultTable = await this._api.upsertSegments(convertedData);
        }
      } catch (e) {
        this.resultTable.push(
          new UpsertSegmnetsResultEntry(
            EUpsertSegmnetsResultStatus.Error,
            `Problem while parsing the csv. Reason: ${e.message}`,
          ),
        );
        this.selectedFile = null;
        if (this._fileElement) {
          this._fileElement.files = null;
          this._fileElement.value = null;
        }
      }
    }

    this.showPreloader = false;
    this._api.updateUI();
  }
  private convertToUploadCsvFormat(
    csvRawData: Array<object>,
  ): Array<UpsertSegmnetEntry> {
    let hasParsingErrors = false;
    let result: Array<UpsertSegmnetEntry>;
    if (csvRawData && csvRawData.length > 0) {
      const firstRow = csvRawData[0];
      const columns = Object.keys(firstRow);
      if (
        !columns.includes("Media ID") ||
        !columns.includes("TC IN") ||
        !columns.includes("TC OUT") ||
        !columns.includes("Description")
      ) {
        this.resultTable.push(
          new UpsertSegmnetsResultEntry(
            EUpsertSegmnetsResultStatus.Error,
            "Problem while parsing the csv. Bad csv format.",
          ),
        );
      } else {
        result = csvRawData.map(
          (csvRawEntry) =>
            new UpsertSegmnetEntry(
              csvRawEntry["Media ID"],
              csvRawEntry["Description"],
              csvRawEntry["TC IN"],
              csvRawEntry["TC OUT"],
            ),
        );
      }
    } else {
      hasParsingErrors = true;
      this.resultTable.push(
        new UpsertSegmnetsResultEntry(
          EUpsertSegmnetsResultStatus.Error,
          "Problem while parsing the csv.",
        ),
      );
    }

    if (hasParsingErrors) {
      return null;
    }

    return result;
  }

  formatResult(result: UpsertSegmnetsResultEntry) {
    return `${Number.isInteger(result.requestIndex) ? "Row: " + (result.requestIndex + 2) + ", " + result.message : result.message}`;
  }
}

export interface IImportSegmentsViewModelApiProxy {
  fileToRowObjectsArray(file: File): Promise<Array<object>>;
  upsertSegments(
    segments: Array<UpsertSegmnetEntry>,
  ): Promise<Array<UpsertSegmnetsResultEntry>>;
  updateUI();
}
